<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12cVAr3/tc-custom/9783987441912.jpg?1704395748021" alt="This image is the cover for the book Guardians of the Tower and three more stories, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Guardians of the Tower and three more stories, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Four Classic Short Stories from The Golden Age of Science Fiction. Featured here: "Guardians of the Tower", "The Best of Fences", "Stroke of Genius", and "But, I Don't Think" all by Randall Garrett.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Randall Garrett
      </h2>
      
      <p class="authorDescription body article">Gordon Randall Phillip David Garrett (December 16, 1927 – December 31, 1987) was an American science fiction and fantasy author. He was a contributor to Astounding and other science fiction magazines of the 1950s and 1960s. He instructed Robert Silverberg in the techniques of selling large quantities of action-adventure science fiction, and collaborated with him on two novels about men from Earth disrupting a peaceful agrarian civilization on an alien planet.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2d1367ff